export enum InvoiceStandaloneSidebarCurrentScreen {
  HOME = "home",
  REPLACE_PAYMENT = "replace-payment"
}